// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2_Wcu","search":"Settings_search__2NFeJ","filter":"Settings_filter__3aYep"};